import { render, staticRenderFns } from "./GraficoMeiaRosca.vue?vue&type=template&id=b0b50cd6&"
import script from "./GraficoMeiaRosca.vue?vue&type=script&lang=js&"
export * from "./GraficoMeiaRosca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports